(() => {
  const root = document.querySelector("[data-ktts-gallery]");
  if (!root) return;

  const items = Array.from(root.querySelectorAll("[data-ktts-index]"));
  if (!items.length) return;

  const lb = root.querySelector("[data-ktts-lightbox]");
  const lbImg = root.querySelector("[data-ktts-lb-img]");
  const lbTitle = root.querySelector("[data-ktts-lb-title]");
  const lbProfile = root.querySelector("[data-ktts-lb-profile]");
  const btnClose = root.querySelector("[data-ktts-lb-close]");
  const btnPrev = root.querySelector("[data-ktts-lb-prev]");
  const btnNext = root.querySelector("[data-ktts-lb-next]");

  let index = 0;
  let lastFocus = null;

  function readItem(el) {
    return {
      url: el.getAttribute("href") || "",
      alt: el.getAttribute("data-alt") || "",
      profile: el.getAttribute("data-profile") || "",
    };
  }

  function openAt(i) {
    index = (i + items.length) % items.length;
    const data = readItem(items[index]);
    lastFocus = document.activeElement;
    lbImg.src = data.url;
    lbImg.alt = data.alt;
    lbTitle.textContent = data.alt;
    if (data.profile) {
      lbProfile.textContent = data.profile;
      lbProfile.hidden = false;
    } else {
      lbProfile.textContent = "";
      lbProfile.hidden = true;
    }
    lb.classList.add("is-open");
    lb.setAttribute("aria-hidden", "false");
    document.documentElement.style.overflow = "hidden";
    btnClose.focus();
  }

  function close() {
    lb.classList.remove("is-open");
    lb.setAttribute("aria-hidden", "true");
    document.documentElement.style.overflow = "";
    lbImg.removeAttribute("src");
    if (lastFocus && typeof lastFocus.focus === "function") lastFocus.focus();
  }

  function next() {
    openAt(index + 1);
  }

  function prev() {
    openAt(index - 1);
  }

  items.forEach((el) => {
    el.addEventListener("click", (e) => {
      e.preventDefault();
      const i = Number(el.getAttribute("data-ktts-index") || "0");
      openAt(i);
    });
  });

  btnClose?.addEventListener("click", close);
  btnNext?.addEventListener("click", next);
  btnPrev?.addEventListener("click", prev);

  lb?.addEventListener("click", (e) => {
    if (e.target === lb) close();
  });

  document.addEventListener("keydown", (e) => {
    if (!lb.classList.contains("is-open")) return;
    if (e.key === "Escape") close();
    if (e.key === "ArrowRight") next();
    if (e.key === "ArrowLeft") prev();
  });

  // Touch swipe
  let touchX = null;
  lb?.addEventListener(
    "touchstart",
    (e) => {
      touchX = e.changedTouches[0].screenX;
    },
    { passive: true }
  );
  lb?.addEventListener(
    "touchend",
    (e) => {
      if (touchX == null) return;
      const dx = e.changedTouches[0].screenX - touchX;
      touchX = null;
      if (Math.abs(dx) < 50) return;
      if (dx < 0) next();
      else prev();
    },
    { passive: true }
  );
})();
